// src/config.ts
// ---------- Safe helpers ----------
export function getDict() {
    if (!window.__SITE_CONFIG__) {
        throw new Error("SITE CONFIG not loaded. Did you include /config.js before the bundle?");
    }
    return window.__SITE_CONFIG__;
}
export function getConfig(lang = "it") {
    var _a;
    const dict = getDict();
    return (_a = dict[lang]) !== null && _a !== void 0 ? _a : dict.it;
}
